import { useEffect, useState } from "react";
import ContainerBox from "../components/container";
import FormBuilder from "../formBuilder/formBuilder";
import { useAxios } from "../../utils/useAxios";
import DataTable from "../dataTable/dataTable";
import LoadOrdersDetailsId from "../../pages/Master/LoadOrders_details_id";
import { Button } from "@mui/material";
import { PlusIcon } from "../../icons";
import { Modal } from "../../components/ui/modal";
import MuiTabsForm from "../components/Mui/Tabs";

interface props {
  formId: string;
  formIntData?: any;
}
const FormGenerator = ({ formId, formIntData }: props) => {
  const [showList, setShowList] = useState(true);
  const [dataHide, setDataHide] = useState(true);
  const { res, mutate, isPending, error } = useAxios({
    url: "/api/auth/form",
  });
  const {
    res: editRes,
    mutate: editMatate,
    isPending: editIsPending,
    error: editError,
  } = useAxios({
    url: "/api/auth/geteditdata",
  });

  useEffect(() => {
    if (formId) {
      mutate({ formId });
    }
  }, [formId]);

  const handleSplite = () => {
    setDataHide(true);
    showList ? setShowList(false) : setShowList(true);
  };

  const getEdit = (id: any, target: string) => {
    setDataHide(false);
    setShowList(false);
    console.log("5 edit get data");
    editMatate({
      editId: id,
      formId: formId,
      target: target,
    });
  };

  useEffect(() => {
    if (editRes?.data?.dataDelete) {
      mutate({ formId });
      setShowList(true);
    }
  }, [editRes?.data?.dataDelete]);

  const listShow = (e: boolean) => {
    e && setShowList(true);
  };

  if (isPending) {
    return <div>Loading</div>;
  }

  return (
    <>
      {formIntData?.detailsPageId ? (
        <ContainerBox
          title={res?.data?.data?.title + " Details"}
          actions={
            <button
              onClick={handleSplite}
              className={`${showList ? "bg-indigo-500" : "bg-amber-500"}  text-white rounded py-1 p-3`}
            >
              {showList ? "Add" : "Show List"}
            </button>
          }
        >
          <LoadOrdersDetailsId formId={formId} formIntData={formIntData} />
        </ContainerBox>
      ) : (
        <>
          {/* <ContainerBox
            title={res?.data?.data?.title}
            actions={
              <button
                onClick={handleSplite}
                className={`${showList ? "bg-indigo-500" : "bg-amber-500"}  text-white rounded py-1 p-3`}
              >
                {showList ? "Add" : "Show List"}
              </button>
            }
          > */}

          {/* TOD0: need to config form database shobhit */}
          <div>
            {showList ? (
              <DataTable
                getEdit={getEdit}
                formId={formId}
                formIntData={formIntData}
                addButton={
                  <>
                    {![
                      "carrier",
                      "trailer",
                      "vehicle",
                      "drivers",
                      "load",
                    ].includes(formId) && (
                      <Button
                        onClick={handleSplite}
                        startIcon={<PlusIcon width={16} height={16} />}
                      >
                        ADD NEW
                      </Button>
                    )}
                  </>
                }
              />
            ) : (
              <>
                <FormBuilder
                  getformData={res?.data?.data}
                  editdata={dataHide ? {} : editRes?.data?.data}
                  listShow={listShow}
                />
              </>
            )}
          </div>
          {/* <Modal
            isOpen={true}
            onClose={closeModal}
            className="max-w-[700px] m-4"
          >
            <div className="relative w-full p-4 overflow-y-auto bg-white no-scrollbar rounded-3xl dark:bg-gray-900 lg:p-11">
              <div className="px-2 pr-14">
                <h4 className="mb-2 text-2xl font-semibold text-gray-800 dark:text-white/90">
                  Edit Address
                </h4>
                <p className="mb-6 text-sm text-gray-500 dark:text-gray-400 lg:mb-7">
                  Update your details to keep your profile up-to-date.
                </p>
              </div>
              <form className="flex flex-col">
                <div className="px-2 overflow-y-auto custom-scrollbar">
                  <div className="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-2">
                    <div>
                      <Label>Country</Label>
                      <Input type="text" value="United Kingdom" />
                    </div>

                    <div>
                      <Label>City/State</Label>
                      <Input type="text" value="Leeds, East London" />
                    </div>

                    <div>
                      <Label>Postal Code</Label>
                      <Input type="text" value="ERT 2489" />
                    </div>

                    <div>
                      <Label>TAX ID</Label>
                      <Input type="text" value="AS4568384" />
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-2 mt-6 lg:justify-end">
                  <Button size="sm" variant="outline" onClick={closeModal}>
                    Close
                  </Button>
                  <Button size="sm" onClick={handleSave}>
                    Save Changes
                  </Button>
                </div>
              </form>
            </div>
          </Modal> */}
        </>
      )}
    </>
  );
};

export default FormGenerator;
